import clsx from 'clsx'
import Link from 'next/link'
import type { PlantProfileResult } from '../data/fragments/PlantProfileFragment'
import type { UserResult } from '../data/fragments/UserFragment'
import { filterNonEmpty } from '../utils/filterNonEmpty'

import styles from './Author.module.sass'
import { CardPlant } from './CardPlant'
import { Container } from './Container'
import { Flex } from './Flex'
import { Icon } from './Icon'
import { ProfileBadge } from './ProfileBadge'
import { SectionToggler } from './SectionToggler'

export function Author(props: { author: UserResult; plantProfiles: PlantProfileResult[] }) {
	//const plantee = usePlanteeUser()
	return (
		<div className={clsx(styles.wrapper)}>
			<Container view="wide">
				<div className={styles.inner}>
					<Link href="/" className={styles.backLink}>
						<Icon name="arrowleft" />
						<span>Back to plant profiles</span>
					</Link>
					<Flex justifyContent="center" marginTop={40} marginBottom={50}>
						<ProfileBadge
							image={
								props.author.avatar ?? {
									url: 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png',
									id: '0',
								}
							}
							name={props.author.nick ?? ''}
							type="public"
							statistics={{
								likes: props.author.likedPlantProfiles.length,
								plants: props.plantProfiles.length,
							}}
							userId={String(props.author.id)}
						/>
					</Flex>
					<SectionToggler headings={[`Plant profiles ${props.plantProfiles.length}`, 'About']}>
						<Flex spacing={20} itemsPerRow={5} mobileItemsPerRow={2} marginTop={50}>
							{props.plantProfiles.map((item, index) => {
								const images = item.activeRevision?.images?.items.sort(
									(a, b) => Number(b.image?.isThumbnail) - Number(a.image?.isThumbnail)
								)
								return (
									<CardPlant
										key={index}
										images={images?.map((item) => item.image).filter(filterNonEmpty) ?? []}
										title={item.activeRevision?.localesByLocale?.name ?? ''}
										user={{
											name: (item.author?.nick || item.author?.email) ?? '',
											image: item.author?.avatar,
											id: String(item.author?.id),
										}}
										likes={1}
										link={`/profile/${item.author?.id}/${item.id}`}
									/>
								)
							})}
						</Flex>
						<p className={styles.about}>{props.author.label}</p>
					</SectionToggler>
				</div>
			</Container>
		</div>
	)
}
